module.exports = __webpack_public_path__ + "prod/1.42.2/img/success-cases-three.bde1d33f.png";